
import React from "react";
import "./OCRDetails.scss";

const OCRDetails = ({ ocrData }) => {
    const isBadPOD = ocrData?.pod?.toLowerCase() === "bad";
    return (
        <div className="ocr-card">
            <div className="ocr-header">
                <h3 className="title">OCR Details</h3>
            </div>
            <table className="ocr-table">
                <tbody>
                    <tr>
                        <td className="label">Pod :</td>
                        <td >
                            <span className={`status-pill ${isBadPOD ? "status-bad" : "status-good"}`}>
                                {ocrData?.pod || "-"}
                            </span>
                        </td>
                    </tr>
                    {isBadPOD && (
                        <tr>
                            <td className="label">Reason :</td>
                            <td>{ocrData?.analysis || "-"}</td>
                        </tr>
                    )}
                    <tr>
                        <td className="label">Docket Number :</td>
                        <td>{ocrData?.docket_number || "-"}</td>
                    </tr>
                    <tr>
                        <td className="label">POD Stamp Date :</td>
                        <td>{ocrData?.pod_stamp_dates || "-"}</td>
                    </tr>
                    <tr>
                        <td className="label">Stamps Detected :</td>
                        <td>
                            {
                                [
                                    ocrData?.has_pod_stamp && "POD",
                                    ocrData?.has_abfrl_stamp && "ABFRL"
                                ].filter(Boolean).join(", ") || "-"
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default OCRDetails;
